import { twVariants } from "@/helpers/tw-resolve";

/** Shared border and focus feedback for a field or its compound control surface. */
export const fieldControlStateVariants = twVariants({
  base: "ring-4 ring-transparent transition-colors duration-200 hover:border-border-brand-secondary",
  variants: {
    focus: {
      visible:
        "focus-visible:border-border-brand-secondary focus-visible:ring-border-default focus-visible:outline-hidden",
      within: "focus-within:border-border-brand-secondary focus-within:ring-border-default",
    },
    invalid: {
      true: "border-border-danger!",
    },
  },
  compoundVariants: [
    { focus: "visible", invalid: true, class: "focus-visible:ring-border-danger-tertiary" },
    { focus: "within", invalid: true, class: "focus-within:ring-border-danger-tertiary" },
  ],
  defaultVariants: { focus: "visible" },
});
